import React, { use } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaTachometerAlt,
  FaBuilding,
  FaUsers,
  FaCalendarAlt,
  FaClipboardList,
  FaBell,
  FaUserShield,
  FaStickyNote,
  FaSignOutAlt,
} from "react-icons/fa";

export default function Sidebar() {
  const location = useLocation();
  const loggedInUser = JSON.parse(localStorage.getItem("user"));

  const menu = [
    { name: "Dashboard", path: "/dashboard", icon: <FaTachometerAlt /> },
    { name: "Companies", path: "/companies", icon: <FaBuilding /> },
    { name: "Contacts", path: "/contacts", icon: <FaUsers /> },
    { name: "Meetings", path: "/meetings", icon: <FaCalendarAlt /> },
    { name: "Meeting Notes", path: "/meetingsNotes", icon: <FaStickyNote /> },
    { name: "Calendar", path: "/calendar", icon: <FaCalendarAlt /> },
    { name: "FollowUp", path: "/followup", icon: <FaClipboardList /> },
    { name: "Reminder", path: "/reminder", icon: <FaBell /> },
  ];

  const logout = () => {
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  return (
    <div className="w-64 h-screen flex flex-col justify-between bg-gradient-to-b from-[#030244] to-[#050463] text-white p-4 fixed shadow-2xl">
      <div>
        <h1 className="text-2xl font-bold mb-8 tracking-wide">
          CRM Dashboard
        </h1>

        <div className="flex flex-col gap-2">
          {menu.map((item, index) => {
            const active = location.pathname === item.path;

            return (
              <Link
                key={index}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-2 rounded-lg text-[16px] transition-all duration-200
                ${
                  active
                    ? "bg-white text-[#030244] font-semibold shadow"
                    : "hover:bg-white/10"
                }`}
              >
                <span className="text-xl">{item.icon}</span>
                {item.name}
              </Link>
            );
          })}

          {loggedInUser?.role === "super_admin" && (
            <Link
              to="/users"
              className={`flex items-center gap-3 px-4 py-2 rounded-lg text-[16px] transition-all duration-200
              ${
                location.pathname === "/users"
                  ? "bg-white text-[#030244] font-semibold shadow"
                  : "hover:bg-white/10"
              }`}
            >
              <FaUserShield className="text-xl"/>
              Users
            </Link>
          )}
        </div>
      </div>
     
      <div className="flex flex-col gap-3">
      
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-white text-[#030244] flex text-2xl items-center justify-center font-bold">
            {loggedInUser?.name?.charAt(0)?.toUpperCase() || "U"}
          </div>

          <div className="flex flex-col leading-tight">
            <span className="text-[17px] font-medium">
              {loggedInUser?.name || "User"}
            </span>

            <span className="text-[14px] text-gray-300 truncate max-w-[140px] mt-0.5">
              {loggedInUser?.email}
            </span>
          </div>
        </div>

        <button
          onClick={logout}
          className="flex items-center gap-2 w-full bg-[#ee1212] hover:bg-red-600 px-3 py-1.5 rounded-lg text-md justify-center transition mt-1"
        >
          <FaSignOutAlt />
          Logout
        </button>
      </div>
    </div>
  );
}

// import { Link } from "react-router-dom";

// export default function Sidebar(){

//   // ✅ get logged user
//   const loggedInUser = JSON.parse(localStorage.getItem("user"));

//   return(

//     <div className="w-60 h-screen bg-gray-900 text-white p-5 fixed">

//       <h1 className="text-xl font-bold mb-6">CRM</h1>

//       <div className="flex flex-col gap-4">

//         <Link to="/dashboard">Dashboard</Link>
//         <Link to="/companies">Companies</Link>
//         <Link to="/contacts">Contacts</Link>
//         <Link to="/meetings">Meetings</Link>
//         <Link to="/meetingsNotes">Meetings Notes</Link>
//         <Link to="/calendar">Calendar</Link>
//         <Link to="/followup">FollowUp</Link>
//         <Link to="/reminder">Reminder</Link>

//         {/* ✅ ONLY SUPER ADMIN */}
//         {loggedInUser?.role === "super_admin" && (
//           <Link to="/users">Users</Link>
//         )}

//       </div>

//     </div>
//   );
// }
